<div class="page-wrapper" *ngIf="isTranslationLoaded">
  <div class="header">
    <qai-inner-wrap>
      <div class="breadcrumb-container">
        <qai-breadcrumb-list
          [items]="getBreadcrumbItems()"
        ></qai-breadcrumb-list>
      </div>

      <h2 class="header_title">{{ simulation?.moduleName }}</h2>
    </qai-inner-wrap>
  </div>

  <qai-inner-wrap *ngIf="isLoading" class="loading-container">
    <qai-loading
      [label]="'personalizedPractice.LOADING' | transloco"
      [size]="'medium'"
    ></qai-loading>
  </qai-inner-wrap>

  <app-scenario-details
    *ngIf="!isLoading && simulation && simulation.isActive"
    [simulation]="simulation"
  ></app-scenario-details>

  <app-personalized-practice-previous-sessions
    *ngIf="!isLoading && simulation"
    [isComplete]="isComplete"
    [isActive]="isActive"
  ></app-personalized-practice-previous-sessions>
</div>
